import { Outlet, useLocation } from 'react-router-dom'

import { Spinner as Loading } from '@factorialco/deprecated-design-system'
import { Features } from 'generated/featureDefinitions'
import { PlanSettingsRootPageDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import Plans from 'modules/billing/components/Plans'
import CollectionsBootstrap from 'modules/billing/lib/SettingsCollectionsBootstrap'

import { PlanSettingsContextProvider } from './PlansSettingsContext'

const Container = () => {
  const { navigation } = useNavigation()
  const location = useLocation()

  const { data, error } = useQuery(PlanSettingsRootPageDocument, {
    variables: {
      featureIds: [Features.expenses_per_user_pricing_create_expenses],
    },
  })

  if (error) throw new Error('Error fetching data')
  if (!data) return <Loading />

  const hasAccess = () => {
    return data.billing._policies.subscriptionManageSubscription.can
  }

  return (
    <AuthorizeUser authorizeFn={() => hasAccess()}>
      <PlanSettingsContextProvider data={data}>
        {location.pathname === navigation.settings.plans.expenses.fullPath() ? (
          <Outlet />
        ) : (
          <Plans />
        )}
      </PlanSettingsContextProvider>
    </AuthorizeUser>
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
